module.exports = __webpack_public_path__ + "static/img_4756-37452103973616424c884fbfb254a8bc.webp";